<template>
  <div>
    <div v-if="getProduct && getProduct.isInShop">
      <div class="product-header">
        <div class="product-preview">
          <div class="shop-breadcrumb">
            <NuxtLink class="breadcrumb--back" :to="getRouteToHome()">{{ $t("konf_Back") }}</NuxtLink>
            <NuxtLink class="breadcrumb--link" :to="getRouteToHome()">Home</NuxtLink>
            <span class="breadcrumb--divider">/</span>
            <span class="breadcrumb--current">{{ getProduct.nameImShop }}</span>
          </div>
          <div class="preview-image">
            <ClientOnly>
            <inner-image-zoom
                :src="productImageUnZoomed"
                :alt="imageAltText(getProduct.nameImShop)" :title="imageAltText(getProduct.nameImShop)"
                :zoomSrc="productImageZoomed"
                className="preview-zoom"
            />
            </ClientOnly>
            <span class="turn-left previewchanger" @click="rotateImage()"></span>
          </div>
        </div>
        <div class="product-content">
          <h1 class="product-content--title">{{ getProduct.nameImShop }}</h1>
          <h4 class="product-content--subtittle">{{ getProduct.produkt }}</h4>
          <div class="product-content--description">
            <ProductViewDetails :details="getProduct.features"/>
          </div>
          <div class="product-content--price">
            <span>{{ $n(parseFloat(getProduct.shopPrice), {key: 'currency', currency: waehrung}) }}</span>
            <span>{{ $t("konfi_inklMWST_only") }} </span>
          </div>
          <div class="product-content--deliverytime">{{ lieferzeit }}</div>
          <div class="product-content--personalize" v-if="getProduct.isPersonalisierbar">
            <ExemplaryData :product="getProduct"/>
          </div>
          <ProductViewCurrentSizes v-if="countSizes>1" :product="getProduct" :selectedColorVariant="selectedColorVariant" :sizeMissing="sizeMissing"
                                   @resetErrors="resetErrors"/>
          <div class="not-available" v-if="!bestellbar">
            <span>{{ $t("shop_product_not_existing_caption") }} </span>
          </div>
          <div class="colors-header">
            <h3 v-if="getProduct.produktFarben.length > 0">{{ $t("shop_produktfarben") }}</h3>
          </div>
          <div class="colors-container">
            <div v-if="getProduct.produktFarben.length > 0"
                 v-for="(color, index) in getProduct.produktFarben"
                 :key="index"
                 class="color-variant">
              <span v-if="color.addedToShop" class="color-element--color" :style="getRGBColor(color)" @click="changeColorVariant(color)"></span>
            </div>
          </div>
          <!--<ClientOnly>-->
            <div class="product-content--goessenguide" @click="changeToGroessenTab()" v-if="getProduct.possibleSizes.length > 1">
              <span class="icon-sizes"></span>
              <span class="text-sizes">{{ $t("shop_groessenguide") }}</span>
            </div>
            <div class="product-content--amount">
              <span class="text-amount">{{ $t("konf_Amount") }}</span>
              <input type="number" id="amount" min="1" max="9999" size="4" v-model="amount" class="input-amount" data-min="1" data-max="9999">
            </div>
            <div class="product-content--btn" v-if="bestellbar">
              <span v-if="!savingToWarenkorb" class="km__button--standard blue" @click="inWarenkorbLegen()">{{ $t("konf_toBasket") }}</span>
              <span v-else class="km__button--standard blue"><SpinningCircleAnimation/></span>
            </div>
         <!-- </ClientOnly>-->
        </div>
      </div>
      <div id="tabs" class="product-content-more">
        <Tabs :initialTab="$t('details')" ref="buttonRef">
          <Tab :name="$t('details')">
            <ProductHighlightsAndTechnologien/>
          </Tab>
          <Tab :name="$t('Groessen')" v-if="getProduct.possibleSizes.length > 1">
            <ProductViewSizeExplained :produkt="getProduct.auwiProdukt" :sport="getProduct.sport"/>
          </Tab>
        </Tabs>
      </div>

    </div>
    <div v-else>
      <FourOFour/>
    </div>
  </div>
</template>

<script lang="ts">

import {computed, type Ref, ref, watch} from "vue";
import {useRoute} from 'vue-router';
import ProductViewDetails from "~/components/ProductViewDetails.vue";
import ProductViewSizeExplained from "~/components/ProductViewSizeExplained.vue";
import ProductViewCurrentSizes from "~/components/ProductViewCurrentSizes.vue";
import ProductHighlightsAndTechnologien from "~/components/ProductHighlightsAndTechnologien.vue"
import ExemplaryData from "~/components/ExemplaryData.vue";
import Tabs from '@global/components/Tabs.vue';
import Tab from '@global/components/Tab.vue'
import {getRouteToHome} from "~/_router/routeUtils";
import {useI18n} from "vue-i18n";
import 'vue-inner-image-zoom/lib/styles.min.css';
import InnerImageZoom from 'vue-inner-image-zoom';
import FourOFour from "~/components/FourOFour.vue";
import {type ShopItem, useShopItems} from "~/store/shopItemsStore";
import {useProductStore} from "~/store/productstore";
import {useShopInfos} from "~/store/shopInfosStore";
import LoadingComponent from "~/components/LoadingComponent.vue";
import {setHeadTags} from "~/metatags/metatags.ts";
import {useShopSeiten} from "~/store/shopSeitenStore";
import {insertCloudflareDownscalingIntoURL} from "@k/global/globalUtils";
import {displayConfirmationDialog} from "@km/components/popups/ConfirmOrConfirmCancelDialog";
import axios from "axios";

export default {
  name: "ProductDetail",
  components: {
    LoadingComponent,

    FourOFour,
    ExemplaryData,
    ProductViewCurrentSizes,
    ProductViewDetails,
    ProductHighlightsAndTechnologien,
    ProductViewSizeExplained,
    Tabs,
    Tab,
    'inner-image-zoom': InnerImageZoom,

  },
  async setup() {
    const route = useRoute();
    const i18n = useI18n();
    const reqEvent = useRequestEvent();
    const sizeMissing = ref(false);
    const imageIndex = ref(0);
    const buttonRef = ref(null);
    const shopItems = useShopItems();
    const shopseite = useShopSeiten();
    const shopinfos = useShopInfos();
    const leaving = ref(false);
    const savingToWarenkorb = ref(false);
    const amount = ref(1);
    const selectedColorVariant = ref(-1);
    const previewRendered = ref(true);
    onBeforeUnmount(()=>{
      leaving.value = true;
    })

    const allShopItems = computed(() => shopItems.allShopItems);
    const shopUUID = route.params.id;
    const allFormerItems = computed(() => shopItems.allFormerItems);
    const getProduct = computed(() => {
      let produkt = allShopItems.value.shopitems.find(item => item.shopUUID === shopUUID) as ShopItem|undefined;
      if (produkt === undefined) {
        produkt = allFormerItems.value.formerShopItems.find(item => item.ShopUUID === shopUUID) as ShopItem | undefined;
          // if(produkt === undefined){
          //   // throw createError({
          //   //   statusCode: 404,
          //   //   message: 'Item not available',
          //   //   fatal: true
          //   // })
          // }
      }

      return produkt;
    }) as Ref<ShopItem | undefined>;
    const productStore = useProductStore();
    const shopInfos = useShopInfos();
    const getProduktFeatures = computed(() => {
      if (!getProduct.value) {
        return "";
      }

      return getProduct.value.features.map(object => object.feature).join(",");
    });

    const productImageUnZoomed = computed(()=>{
      if (!getProduct.value) {
        return "";
      }

      let saveID = selectedColorVariant.value>-1 ? selectedColorVariant.value : getProduct.value.saveID;
      let url = insertCloudflareDownscalingIntoURL(getProduct.value.previewPath + saveID + '_' + imageIndex.value + '.png', 550, 550);
      if(!previewRendered.value){
        url = "https://static.owayo-cdn.com/newhp/img/productHome/artikel/big/productselection-dummy.jpg";
      }

      return url;
    });

    const productImageZoomed = computed(()=>{
      if (!getProduct.value) {
        return "";
      }

      let saveID = selectedColorVariant.value>-1 ? selectedColorVariant.value : getProduct.value.saveID;
      let url = insertCloudflareDownscalingIntoURL(getProduct.value.previewPath + saveID + '_' + imageIndex.value + '.png', 1000, 1000);
      if(!previewRendered.value){
        url = "https://static.owayo-cdn.com/newhp/img/productHome/artikel/big/productselection-dummy.jpg";
      }

      return url;
    });
    const url = useRequestURL();

    const lieferzeit = ref('');

    const getLieferzeit = async() => {
      if (!getProduct.value) {
        return "";
      }

      const wochen = await axios.post('/shop_php/getDeliveryTimeForProduct.php', {land: shopInfos.getShopLand, ordertype: getProduct.value.ordertype, product:getProduct.value.auwiProdukt});
      lieferzeit.value = i18n.t("shop_lieferzeit").replace("[Lieferzeit]", wochen.data as string);
    }

    onMounted(() => {
      if (!getProduct.value) {
        return "";
      }

      const productId = 123; // Beispiel: Ersetze durch die tatsächliche Produkt-ID
      getLieferzeit();
    });

    if(getProduct.value) {
      setHeadTags(
          shopInfos.getShopSprache,
          shopInfos.getShopLand,
          shopinfos.shopname,
          shopseite.getProduktSeite?.BeschreibungContent || "",
          getProduct.value.previewPath + getProduct.value.saveID + '_0.png',
          {
            shopUUID: getProduct.value.shopUUID,
            preis: getProduct.value.shopPrice,
            currencyCode: shopInfos.getStandardWaehrung
          },
          url.toString()
      );

      if (getProduct.value.isInShop) {
        productStore.loadSizesInfo({sport: getProduct.value.sport, webproduct: getProduct.value.webproduct});
        productStore.loadProductDetails({
          sport: getProduct.value.sport,
          webproduct: getProduct.value.webproduct,
          saveID: getProduct.value.saveID
        });
        // generateJsonLd(shopInfos.shopname, getProduct.value.saveID, getProduct.value.shopPrice, getProduct.value.shopUUID).then(response => {
        //   useHead({
        //     script: [
        //       {
        //         hid: "productinfo",
        //         type: "application/ld+json",
        //         children: response
        //       }
        //     ]
        //   })
        // });
      } else if (!getProduct.value.isInShop) {
        setResponseStatus(reqEvent, 404)
      }
    }

    watch(() => getProduct.value, (currentProduct) => {
      if (!currentProduct) {
        setResponseStatus(reqEvent, 404);
        return;
      }

      if (currentProduct.isInShop) {
        productStore.loadSizesInfo({sport: currentProduct.sport, webproduct: currentProduct.webproduct});
        productStore.loadProductDetails({sport: currentProduct.sport, webproduct: currentProduct.webproduct, saveID:currentProduct.saveID});
        // useJsonld(() => generateJsonLd(shopInfos.shopname, getProduct.value.saveID, getProduct.value.shopPrice, getProduct.value.shopUUID) as JsonLD)
      }
    });

    function resetErrors() {
      sizeMissing.value = false;
    }

    function rotateImage() {
      resetErrors();
      imageIndex.value = (imageIndex.value === 3) ? 0 : imageIndex.value + 1;
    }

    async function inWarenkorbLegenOhnePersonalisierung() {
      if (shopItems.getGewaehlteGroesse(getProduct.value.saveID) === "Choose your size") {
        sizeMissing.value = true;
      } else {
        const saveID = selectedColorVariant.value>-1 ? selectedColorVariant.value : getProduct.value.saveID;
        savingToWarenkorb.value = true;
        await shopItems.saveItemInWarenkorb({
          item: getProduct.value,
          size: shopItems.getGewaehlteGroesse(getProduct.value.saveID),
          shop: shopInfos.shopname,
          amount: amount.value,
          farbvariantenSaveID: saveID.toString()
        });
        savingToWarenkorb.value = false;
      }
    }

    function getUnveraenderteExemplartexte(){
      return getProduct.value.editableTextGroups.filter((ele)=>{if(ele.Inhalt===ele.value){return ele;}});
    }

    async function savePersonalisiertesItem(saveID){
      sizeMissing.value = false;
      savingToWarenkorb.value = true;
      await shopItems.savePersonalisiertesItemInWarenkorb({item: getProduct.value, shop: shopInfos.shopname, amount: amount.value, farbvariantenSaveID: saveID});
      savingToWarenkorb.value = false;
    }

    async function inWarenkorbLegenMitPersonalisierung() {
      if (shopItems.getGewaehlteGroesse(getProduct.value.saveID) === "Choose your size") {
        sizeMissing.value = true;
      } else {
        const saveID = selectedColorVariant.value>-1 ? selectedColorVariant.value : getProduct.value.saveID;
        const unveraenderteExemplartexte = getUnveraenderteExemplartexte();
        if(unveraenderteExemplartexte.length>0){
          const combinedTextValues = unveraenderteExemplartexte.map(obj => obj.value).reduce((combined, currentValue)=> combined + '<br>' + currentValue);
          const message = i18n.t("shop_texteIdentisch").replace("[Texte]", combinedTextValues);
          displayConfirmationDialog(i18n.t("shop_identischeTexte_Header"), message).then(()=>{
            savePersonalisiertesItem(saveID);
          }).catch(()=> {})
        }
        else{
          await savePersonalisiertesItem(saveID);
        }
      }
    }

    function inWarenkorbLegen() {
      resetErrors();
      getProduct.value.isPersonalisierbar ? inWarenkorbLegenMitPersonalisierung() : inWarenkorbLegenOhnePersonalisierung();
    }

    function imageAltText(produktname:string) {
      return i18n.t("shop_Produktansicht") + ' ' + shopInfos.shopname + ' ' + produktname;
    }

    function changeToGroessenTab() {
      (buttonRef.value as {clickAButtonFromParent:(s:string)=>void}).clickAButtonFromParent(i18n.t('Groessen'));
      const section = document.getElementById("tabs") as HTMLDivElement;
      const offsetTop = section.offsetTop;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }

    function getRGBColor(color){
      return "background-color: rgb("+color.r+", "+color.g+", "+color.b+")";
    }

    function changeColorVariant(color){
      selectedColorVariant.value = color.farbvariantenSaveID;
      previewRendered.value = color.previewRendered;
    }

    function getPossibleSizesCountForProduktFarbe(){
      const saveID = selectedColorVariant.value>-1 ? selectedColorVariant.value : getProduct.value.saveID.toString();
      const selectedProduct = getProduct.value.typ==='Artikel' ? getProduct.value.produktFarben[0] : getProduct.value.produktFarben.filter(obj => obj.farbvariantenSaveID === saveID)[0];
      if(selectedProduct === undefined){
        return getProduct.value.possibleSizes.length;
      }
      return selectedProduct.possibleSizes.length==1 ? 0 : selectedProduct.possibleSizes.length;
    }

    const countSizes = computed(() => getProduct.value.produktFarben.length > 0 ? getPossibleSizesCountForProduktFarbe() : getProduct.value.possibleSizes.length);
    const bestellbar = computed(() => countSizes.value>0 && !getProduct.value.discarded);

    return {
      sizeMissing,
      amount,
      imageIndex,
      allShopItems,
      allFormerItems,
      shopUUID,
      getProduct,
      resetErrors,
      rotateImage,
      inWarenkorbLegenOhnePersonalisierung,
      inWarenkorbLegen,
      getProduktFeatures,
      getRouteToHome,
      imageAltText,
      buttonRef,
      changeToGroessenTab,
      countSizes,
      bestellbar,
      waehrung: computed(() => shopInfos.getStandardWaehrung),
      isDevMode: import.meta.env.DEV,
      productImageUnZoomed,
      productImageZoomed,
      savingToWarenkorb,
      getRGBColor,
      changeColorVariant,
      selectedColorVariant,
      lieferzeit
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~/assets/scss/settings/_config.scss" as *;

input {
  display: block;
  border: none;
  background: $color-grey;
  padding: 6px 10px;
  width: 280px;
  margin-bottom: 10px;
  margin-top: 5px;
}

.turn-left {
  position: absolute;
  bottom: 10px;
  left: 50%;
  width: 30px;
  height: 30px;
  background-image: url("https://static.owayo-cdn.com/konfigurator_html/img/layout/toolbox-drehen-rechts.svg");
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: -15px;
  z-index: 9;
}

.product-content {
  width: calc(100% - 30px);
  margin-left: 30px;

  h3 {
    font-weight: 700;
    text-transform: none;
  }

  &--title {
    font-weight: 700;
    margin-top: 20px;
  }

  &--subtittle {
    margin-bottom: 20px;
  }

  &--price {
    margin-bottom: 5px;

    span {
      &:first-child {
        font-weight: 600;
        font-size: 16px;
        display: inline-block;
      }

      &:last-child {
        display: inline-block;
        padding-left: 5px;
      }
    }
  }

  &--deliverytime {
    margin-bottom: 30px;
  }

  &--personalize {
    margin-bottom: 25px;
  }

  &--order-btn {
    background: $color-red;
    width: 200px;
    text-align: center;
    color: white;
    padding: 6px 10px;
    display: block;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 600;
  }

  &--back-btn {
    background: $color-blue;
    width: 200px;
    text-align: center;
    color: white;
    padding: 6px 10px;
    display: block;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 600;
  }

  &--goessenguide {
    cursor: pointer;
  }
}

.preview-image {
  width: calc(100% - 30px);
  margin-right: 30px;
  /*border: 1px solid $color-grey;*/
  background: #ececec;
  border-radius: 5px;
  height: 550px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  img {
    object-fit: contain;
    max-height: 470px;
  }

  @media (max-width: 940px) {
    height: 470px;

    img {
      width: 100%;
    }
  }

  @media (max-width: 740px) {
    height: auto;

    img {
      max-width: 400px;
      padding: 30px;
    }
  }
}

.product-header {
  display: flex;
  flex-direction: row;
  padding-bottom: 60px;
  position: relative;

  .product-preview {
    width: 65%;
    position: relative;

    @media (max-width: 940px) {
      width: 50%;
    }
  }

  .product-content {
    width: 35%;

    @media (max-width: 940px) {
      width: 50%;
      margin-left: 0;
    }
  }

  @media (max-width: 740px) {
    flex-direction: column;

    .product-preview {
      width: 100%;
    }

    .product-content {
      width: 100%;
    }
  }
}

.product-content--btn {
  display: flex;
  justify-content: space-between;

  .km__button--standard {
    width: 100%;
    height: 40px;
    margin-right: 15px;
  }
}

.product-content--goessenguide {
  display: block;
  margin-bottom: 20px;

  .icon-sizes {
    display: inline-block;
    width: 28px;
    height: 10px;
    background-image: url("data:image/svg+xml;base64,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");
    background-repeat: no-repeat;
    background-size: 28px auto;
    background-position: 0 center;
    transform: scaleY(-1);
    position: relative;
    top: 1px;
  }

  .text-sizes {
    display: inline-block;
    border-bottom: 1px solid $color-black;
    margin-left: 5px;
  }
}

.product-content--amount {
  display: block;
  margin-bottom: 20px;

  .input-amount {
    display: inline-block;
    margin-left: 10px;
    height: 28px;
    width: 50px;
    top: 1px;
  }

  .text-amount {
    display: inline-block;
    margin-left: 5px;
  }
}

.colors-header {
  h3 {
    display: inline-block;
    font-weight: 600;
    font-size: 14px;
  }
}

.not-available{
  font-weight: 600;
  font-size: 14px;
  color: red;
  margin-bottom: 10px;
}

.colors-container {
  margin-bottom: 20px;
  display: flex;
}

.color-variant .color-element--color {
  flex-direction: row;
  width: 25px;
  height: 25px;
  border: 1px solid #cdcdcd;
  display: block; /* ensures the span takes dimensions */
}

</style>
